module.exports = __webpack_public_path__ + "static/media/P1050706-min.d38a3779.JPG";